import { Builder } from '@builder.io/react';
import Section from './Section';

const SectionBuilderConfig = {
  name: 'Core:Section',
  override: true,
  canHaveChildren: true,
  defaultStyles: {
    paddingTop: 'var(--spacing-regular)',
    paddingBottom: 'var(--spacing-regular)',
    paddingLeft: '0',
    paddingRight: '0',
    marginTop: '0',
    marginBottom: '0',
    marginLeft: '0',
    marginRight: '0',
  },
  inputs: [
    {
      name: 'heading',
      type: 'string',
    },
    {
      name: 'isPageTitle',
      defaultValue: false,
      helperText: 'Use for top level title (h1). Note: there should only ever be one per page.',
      type: 'boolean',
    },
    {
      name: 'id',
      type: 'string',
    },
    {
      name: 'noContainer',
      friendlyName: 'Full width',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'noVerticalPadding',
      friendlyName: 'No vertical padding',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'altBackground',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'isArticleContent',
      type: 'boolean',
      defaultValue: false,
    },
  ],
};

Builder.registerComponent(Section, SectionBuilderConfig);
